import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const FontSizeContext = createContext();

export const FontSizeProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [fontSize, setFontSize] = useState(() => {
    const saved = localStorage.getItem('app-font-size');
    return saved ? parseInt(saved, 10) : 100;
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty('--app-height-scale', (fontSize / 100).toString());
    localStorage.setItem('app-font-size', fontSize.toString());
  }, [fontSize]);

  // Auto-open modal on first login if not completed
  useEffect(() => {
    if (currentUser) {
      const isCompleted = localStorage.getItem('calibration-completed');
      if (!isCompleted) {
        setIsModalOpen(true);
      }
    }
  }, [currentUser]);

  const increaseFontSize = () => setFontSize((prev) => Math.min(prev + 5, 150));
  const decreaseFontSize = () => setFontSize((prev) => Math.max(prev - 5, 50));
  const resetFontSize = () => setFontSize(100);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <FontSizeContext.Provider
      value={{
        fontSize,
        setFontSize,
        increaseFontSize,
        decreaseFontSize,
        resetFontSize,
        isModalOpen,
        openModal,
        closeModal,
      }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};

export const useFontSize = () => {
  const context = useContext(FontSizeContext);
  if (!context) {
    throw new Error('useFontSize must be used within a FontSizeProvider');
  }
  return context;
};
